import React, { useState } from 'react';
import { X, MapPin, Phone, Mail, Globe, Save } from 'lucide-react';
import api from '../utils/api';

export default function AddressModal({ isOpen, onClose, barbershopId, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState({
    endereco: '',
    telefone: '',
    email: '',
    website: ''
  });

  const loadAddress = async () => {
    try {
      const response = await api.get(`/barbershops/${barbershopId}`);
      const data = response.data;
      
      if (data) {
        setAddress({
          endereco: data.endereco || '',
          telefone: data.telefone || '',
          email: data.email || '',
          website: data.website || ''
        });
      }
    } catch (error) {
      console.error('Erro ao carregar endereço:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await api.put(`/barbershops/${barbershopId}`, address);
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Erro ao salvar endereço:', error);
      alert('Erro ao salvar endereço. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      loadAddress();
    }
  }, [isOpen, barbershopId]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <MapPin className="w-6 h-6 text-purple-500" />
            <h2 className="text-xl font-bold text-white">Endereço e Contato</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-700 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Endereço */}
          <div className="card p-4">
            <h3 className="text-lg font-semibold text-white mb-4">Endereço</h3>
            
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Endereço completo
                </label>
                <input
                  type="text"
                  value={address.endereco}
                  onChange={(e) => setAddress({...address, endereco: e.target.value})}
                  className="input"
                  placeholder="Rua, número, bairro, cidade - Estado"
                  required
                />
              </div>
            </div>
          </div>

          {/* Contato */}
          <div className="card p-4">
            <h3 className="text-lg font-semibold text-white mb-4">Contato</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Telefone
                </label>
                <input
                  type="tel"
                  value={address.telefone}
                  onChange={(e) => setAddress({...address, telefone: e.target.value})}
                  className="input"
                  placeholder="(00) 00000-0000"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  E-mail
                </label>
                <input
                  type="email"
                  value={address.email}
                  onChange={(e) => setAddress({...address, email: e.target.value})}
                  className="input"
                  placeholder="contato@barbearia.com"
                />
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Website
                </label>
                <input
                  type="url"
                  value={address.website}
                  onChange={(e) => setAddress({...address, website: e.target.value})}
                  className="input"
                  placeholder="https://www.barbearia.com"
                />
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-700">
            <button
              type="button"
              onClick={onClose}
              className="btn-ghost px-6 py-2 bg-gray-700 text-gray-300 hover:bg-gray-600"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary px-6 py-2 bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-50"
            >
              {loading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <>
                  <Save className="w-4 h-4 mr-2" />
                  Salvar dados
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
